import { render, staticRenderFns } from "./partyRelationSingleSelectTree.vue?vue&type=template&id=2b737758&scoped=true&"
import script from "./partyRelationSingleSelectTree.vue?vue&type=script&lang=js&"
export * from "./partyRelationSingleSelectTree.vue?vue&type=script&lang=js&"
import style0 from "./partyRelationSingleSelectTree.vue?vue&type=style&index=0&id=2b737758&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b737758",
  null
  
)

export default component.exports